import { InstagramLiveIcon } from '@mm/icons/StarterIcons';
import quoteImg from 'assets/icons/quote.svg';
import React from 'react';
import { colors } from '../../../../beta/styles/colors';
import './IGLiveCommentMessage.pcss';

type Props = {
  displayText: string;
};

export const IGLiveCommentMessage = (props: Props) => {
  const { displayText } = props;

  return (
    <div className="ig-live-comment-message__container">
      <div className="ig-live-comment-message__title">
        <InstagramLiveIcon
          className="ig-live-comment-message__icon"
          color={colors.accentBlue}
        />
        User left a comment on your live
      </div>
      <div className="ig-live-comment-message__body">
        <img className="ig-live-comment-message__quote" src={quoteImg} />
        {displayText}
      </div>
    </div>
  );
};
